<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content" :class="isZh ? 'content-zh' : 'content-en'">
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block">
            <p v-html="section"></p>
          </div>
        </div>

        <!-- Picture 1 after paragraph 1 (index 1) -->
        <div v-if="index === 1 && (currentNews as any).other?.picture1" class="content-section image-section">
          <div class="image-container">
            <img :src="(currentNews as any).other.picture1.url" :alt="(currentNews as any).other.picture1.caption">
            <p v-if="(currentNews as any).other.picture1.caption" class="image-caption">{{ (currentNews as any).other.picture1.caption }}</p>
          </div>
        </div>

        <!-- Picture 2 after paragraph 6 (index 6) for Chinese or index 5 for English -->
        <div v-if="((index === 6 && isZh) || (index === 5 && !isZh)) && (currentNews as any).other?.picture2" class="content-section image-section">
           <div class="image-container">
               <img :src="(currentNews as any).other.picture2.url" :alt="(currentNews as any).other.picture2.caption">
               <p v-if="(currentNews as any).other.picture2.caption" class="image-caption">{{ (currentNews as any).other.picture2.caption }}</p>
           </div>
        </div>

      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const isZh = computed(() => langStore.currentLang.startsWith('zh'));

const currentNews = computed(() => {
  const translationData = isZh.value ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'quanchaodaoyonghuciti356t');
  return newsItem || {};
});

const contentSections = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});
</script>

<style scoped>
.page-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: right;
}

.content {
  line-height: 1.8;
  color: #444;
}

.content-section {
  margin-bottom: 20px;
}

.content-zh .text-block :deep(p) {
  margin: 0;
  text-align: justify;
  text-indent: 2em;
}

.content-en .text-block :deep(p) {
  margin: 0;
  text-align: justify;
  text-indent: 0;
}

.text-block :deep(a) {
  color: #1677FF;
  text-decoration: underline;
}

.text-block :deep(h2) {
  color: #0066cc;
  font-weight: bold;
  margin: 20px 0 10px 0;
}

.text-block :deep(h3) {
  color: #0066cc;
  font-weight: bold;
  margin: 15px 0 8px 0;
}

.image-section {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.image-container {
  max-width: 100%;
  text-align: center;
}

.image-container img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.image-caption {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style>
